import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Hypotheek } from '@/model/Hypotheek';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import AppHypotheekgeversVue from '../hypotheekgevers/AppHypotheekgevers.vue';

@Component({
  components: {
    'app-hypotheekgevers': AppHypotheekgeversVue
  }
})
export default class AppHypotheekData extends Mixins(AppFiltersMixin) {
  @Prop()
  public hypotheek!: Hypotheek;

  public get isLongRisicoklasse(): boolean {
    return !!(
      this.hypotheek &&
      this.$options &&
      this.$options.filters &&
      this.$options.filters.appRisicoklasse(this.hypotheek.risicoklasse).length > 15
    );
  }

  public get hasHypotheekgevers(): boolean {
    return this.hypotheek && this.hypotheek.hypotheekgevers && this.hypotheek.hypotheekgevers.length > 0;
  }
}
